export default{

    setSoloGameState: (state, soloGame) => {
        state.soloGame.push(soloGame)
    },
    setSoloGameRequest: (state, soloGame) => {
        state.soloGame = soloGame
    },
    resetSoloGameState: (state) => {
        state.soloGame = []
    },
    setGameSetIdState: (state, gameSetId) => {
        state.gameSetId = gameSetId
    },
    setNowState: (state, now) => {
        state.now = now
    }
}